export default __webpack_public_path__ + "static/media/empty-ellipsis.438602db.svg";